import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Input } from "@faire/web--source/slate/Input";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { createToast } from "@faire/web--source/slate/Toast";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import supportArticle from "@faire/web-api--source/routes/support/articles/articleId";
import React from "react";
import styled from "styled-components";
import { isValidEmail } from "@faire/retailer/lib/validation";
import { INVITE_TOAST_AUTO_DISMISS_TIME_MS } from "@faire/retailer/views/settings/manage-users/common/const";
import { InviteUserToast } from "@faire/retailer/views/settings/manage-users/common/InviteUserToast";
import { useInviteUser } from "@faire/retailer/views/settings/manage-users/common/useInviteUser";
var LinkFormatting = function(chunks, link) {
    return /*#__PURE__*/ _jsx(EmbeddedLink, {
        linkTo: link,
        target: "_blank",
        color: Core.text.subdued,
        children: chunks
    });
};
export var InviteTeamMemberSection = function(param) {
    var onInviteSent = param.onInviteSent, onInviteButtonClick = param.onInviteButtonClick;
    var _React_useState = _sliced_to_array(React.useState(""), 2), emailAddress = _React_useState[0], setEmailAddress = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(""), 2), errorMessage = _React_useState1[0], setErrorMessage = _React_useState1[1];
    var strictLocalize = useStrictLocalization().strictLocalize;
    var learnMoreLink = supportArticle("8675579278619");
    var invalidEmailErrorMessage = strictLocalize({
        id: "I4p1eb",
        defaultMessage: [
            {
                type: 0,
                value: "Invalid email address"
            }
        ]
    });
    var handleInputChange = function(e) {
        setEmailAddress(e.target.value);
    };
    var handleInviteUser = useInviteUser().handleInviteUser;
    var validateEmail = function() {
        if (!emailAddress.trim()) {
            setErrorMessage(invalidEmailErrorMessage);
            return false;
        }
        if (!isValidEmail(emailAddress.trim())) {
            setErrorMessage(invalidEmailErrorMessage);
            return false;
        }
        return true;
    };
    var createInviteSentToast = function(userDetails) {
        createToast(/*#__PURE__*/ _jsx(InviteUserToast, {
            email: userDetails.email,
            accountToken: userDetails.accountToken
        }), {
            icon: "foundation:Send",
            timeout: INVITE_TOAST_AUTO_DISMISS_TIME_MS
        });
    };
    var handleInvite = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var email, _ref, error, accountUserToken;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        onInviteButtonClick === null || onInviteButtonClick === void 0 ? void 0 : onInviteButtonClick();
                        if (!validateEmail()) {
                            return [
                                2
                            ];
                        }
                        setErrorMessage("");
                        email = emailAddress.trim();
                        return [
                            4,
                            handleInviteUser(email)
                        ];
                    case 1:
                        _ref = _state.sent(), error = _ref.error, accountUserToken = _ref.accountUserToken;
                        if (error) {
                            setErrorMessage(error);
                            return [
                                2
                            ];
                        }
                        createInviteSentToast({
                            email: email,
                            accountToken: accountUserToken !== null && accountUserToken !== void 0 ? accountUserToken : ""
                        });
                        onInviteSent === null || onInviteSent === void 0 ? void 0 : onInviteSent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleInvite() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx(Input, {
                        label: strictLocalize({
                            id: "RAaA3l",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Email address"
                                }
                            ]
                        }),
                        "data-test-id": "invite-user-email-address-input",
                        value: emailAddress,
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsx(InviteButton, {
                        variant: "secondary",
                        small: true,
                        onClick: handleInvite,
                        "data-test-id": "invite-user-button",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "dFHB2m",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Invite"
                                }
                            ]
                        })
                    })
                ]
            }),
            errorMessage ? /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.critical,
                children: errorMessage
            }) : null,
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.subdued,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "JA1lEz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Account owners are ultimately responsible for team member actions on their account. "
                        },
                        {
                            type: 8,
                            value: "LinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Learn more"
                                }
                            ]
                        }
                    ],
                    values: {
                        LinkFormatting: function(chunks) {
                            return LinkFormatting(chunks, learnMoreLink);
                        }
                    }
                })
            })
        ]
    });
};
var InviteButton = styled(Button).withConfig({
    componentId: "sc-7075dc5b-0"
})([
    "align-self:end;"
]);
